<template>
  <small class="note">
    {{ $t('common.mailSmsLegendText.desc1') }}<br>
    <strong>{id}</strong> - {{ $t('common.mailSmsLegendText.desc2') }}<br>
    <strong>{data}</strong> - {{ $t('common.mailSmsLegendText.desc3') }}<br>
    <strong>{godzina}</strong> - {{ $t('common.mailSmsLegendText.desc4') }}<br>
    <strong>{usluga}</strong> - {{ $t('common.mailSmsLegendText.desc5') }}<br>
    <strong>{kategoria_uslugi}</strong> - {{ $t('common.mailSmsLegendText.desc6') }}<br>
    <strong>{pracownik}</strong> - {{ $t('common.mailSmsLegendText.desc7') }}<br>
    <strong>{pracownik_email}</strong> - {{ $t('common.mailSmsLegendText.desc8') }}<br>
    <strong>{google_meet_url}</strong> - {{ $t('common.mailSmsLegendText.desc9') }}<br>
    <strong>{nazwa_terminu_uslugi}</strong> - {{ $t('common.mailSmsLegendText.desc10') }}
  </small>
</template>

<script>
export default {
  name: 'mail-sms-legend-text'
};
</script>



// WEBPACK FOOTER //
// src/components/common/MailSmsLegendText.vue